module.exports = __webpack_public_path__ + "img/Maskgroup.2d174fd4.png";